import { Box, Typography, FormControl, Select, MenuItem, Stack } from "@mui/material";
import { useResponsive } from "../../../utils/mobileresponsive.js";
import { StyledDatePicker, datePickerPopperSx } from "../../../components/ui/CalendarPopper.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FirstRowElementsComponent } from "../../ClientList/components/ClientListParts.jsx";
import dayjs from "dayjs";

const CATEGORY_OPTIONS = ["All", "Bug", "Enhancement", "Question"];
const STATUS_OPTIONS = ["All", "Pending", "In Progress", "Blocked", "Completed"];

const TableFilters = ({ filters, setFilters, searchTerm, onSearchChange, isAgent }) => {
	const { isMobile } = useResponsive();

	const handleDateFrom = (val) => {
		setFilters((f) => ({
			...f,
			date_from: val ? dayjs(val).format("YYYY-MM-DD") : "",
			offset: 0,
		}));
	};

	const handleDateTo = (val) => {
		setFilters((f) => ({
			...f,
			date_to: val ? dayjs(val).format("YYYY-MM-DD") : "",
			offset: 0,
		}));
	};

	const handleCategory = (e) => {
		setFilters((f) => ({
			...f,
			category: e.target.value === "All" ? "" : e.target.value,
			offset: 0,
		}));
	};

	const handleStatus = (e) => {
		setFilters((f) => ({
			...f,
			status: e.target.value === "All" ? "" : e.target.value,
			offset: 0,
		}));
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Box sx={{ px: 2, mb: 2 }}>
				{/* DATE RANGE */}
				{!isAgent && (
					<Stack
						direction={{ xs: "column", md: "row" }}
						spacing={1}
						alignItems={{ xs: "stretch", md: "center" }}
						justifyContent="flex-end"
						mb={4}
					>
						<Typography fontWeight={600}>Date Submitted:</Typography>

						<Stack direction="row" spacing={1} alignItems="center">
							<Box sx={{ width: 170 }}>
								<StyledDatePicker
									label="From"
									value={filters.date_from ? dayjs(filters.date_from) : null}
									onChange={handleDateFrom}
									slotProps={{
										textField: { size: "small" },
										popper: { sx: datePickerPopperSx },
									}}
								/>
							</Box>

							<Typography color="text.secondary">—</Typography>

							<Box sx={{ width: 170 }}>
								<StyledDatePicker
									label="To"
									value={filters.date_to ? dayjs(filters.date_to) : null}
									onChange={handleDateTo}
									minDate={filters.date_from ? dayjs(filters.date_from) : undefined}
									slotProps={{
										textField: { size: "small" },
										popper: { sx: datePickerPopperSx },
									}}
								/>
							</Box>
						</Stack>
					</Stack>
				)}

				{/* CATEGORY + STATUS */}
				<Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center" justifyContent="space-between">
					{/* CATEGORY */}
					<Stack direction="row" spacing={2}>
						<Stack direction="row" spacing={1} alignItems="center">
							<Typography fontWeight={600}>Category:</Typography>
							<FormControl size="small" sx={{ minWidth: 160 }}>
								<Select value={filters.category || "All"} onChange={handleCategory}>
									{CATEGORY_OPTIONS.map((opt) => (
										<MenuItem key={opt} value={opt}>
											{opt}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Stack>

						{/* STATUS */}
						<Stack direction="row" spacing={1} alignItems="center">
							<Typography fontWeight={600}>Status:</Typography>
							<FormControl size="small" sx={{ minWidth: 160 }}>
								<Select value={filters.status || "All"} onChange={handleStatus}>
									{STATUS_OPTIONS.map((opt) => (
										<MenuItem key={opt} value={opt}>
											{opt}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Stack>
					</Stack>
					<Stack direction="row" alignItems="center !important" spacing={1}>
						<Typography fontWeight={600} sx={{ whiteSpace: "nowrap" }}>
							Search:
						</Typography>
						<FirstRowElementsComponent
							searchTerm={searchTerm}
							onSearchChange={onSearchChange}
							placeHolder={isAgent ? "Ticket ID" : "Ticket ID, Agent Name"}
						/>
					</Stack>
				</Stack>
			</Box>
		</LocalizationProvider>
	);
};

export default TableFilters;
